import Vue from 'vue'

export default {
  state: {
    language: window.config.language.default
  },
  getters: {
    translations: () => (key) => {
      return Vue.i18n.translate(key)
    },
    urlLanguagePrefix: state => {
      if (state.language === window.config.language.default) {
        return ''
      } else {
        return '/' + state.language
      }
    },
    isUkLanguage: state => {
      return state.language === 'uk'
    }
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
    }
  }
}
